/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disabled no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { IBEError } from '@common/interfaces/be-error.interface';
import { CustomAxiosResponse } from '@common/interfaces/custom-axios-response.interface';
import { CustomPromise } from '@common/interfaces/custom-promise.interface';
import { IRequestService, requestService } from '@common/services/request.service';
import { formatUrl } from '@common/utils/format-url.util';
import { BE_API_URLS } from '@src/shared/be-api-urls.constant';

const API_SERVER_URL = BE_API_URLS.packHouseService.apiUrl;

// DON'T REMOVE THIS COMMENTS!!! Code between comments auto-generated
// INSERT START
export enum EStockStatus {
    empty = 'empty',
    running_out = 'running_out',
    available = 'available',
}
export enum EDeliveryDay {
    Mon = 'Mon',
    Tue = 'Tue',
    Wed = 'Wed',
    Thu = 'Thu',
    Fri = 'Fri',
    Sat = 'Sat',
    Sun = 'Sun',
}
export enum EPackhouseV1SalesConfigByDeliveryIdIdGet_Add_on_type {
    add_on = 'add-on',
    shop_add_on = 'shop-add-on',
}
export enum EPackhouseV1ProductCatalogGet_Type {
    all = 'all',
    plan = 'plan',
    addon = 'addon',
    fee_addon = 'fee-addon',
    shop_addon = 'shop-addon',
}
export enum EPackhouseV2ProductCatalogGet_Type {
    all = 'all',
    plan = 'plan',
    addon = 'addon',
    fee_addon = 'fee-addon',
    shop_addon = 'shop-addon',
}
export enum EPackhouseV2ProductCatalogGet_Status {
    active = 'active',
    archived = 'archived',
    hidden = 'hidden',
}
export enum EPackhouseV2ProductCatalogIdGet_Type {
    all = 'all',
    plan = 'plan',
    addon = 'addon',
    fee_addon = 'fee-addon',
    shop_addon = 'shop-addon',
}
export interface IPostcode {
    post_code?: string;
}
export interface IAddress {
    id?: string;
    address?: string;
}
export interface IProductsCustomisations {
    product_code?: string;
    swapped_code?: string;
}
export interface IPutBoxCustomisationSelectionRequestBody {
    box_customisation_config_id?: string;
    product_customisations?: Array<IProductsCustomisations>;
}
export interface IPromotion {
    sales_config_id?: string;
    promotion_type?: string;
    promotion_data?: {
        label?: string;
        description?: string;
        price_override?: number;
    };
}
export interface IValidePostcodeResponse {
    valid?: boolean;
    delivery_configurations?: Array<string>;
    list?: Array<IDeliveryConfiguration>;
}
export interface IValideDeliveryAddress {
    status?: string;
    valid?: boolean;
    error?: string;
}
export interface ISubscriptionSCsForSale {
    list?: Array<ISubscriptionSCForSale>;
    next_page?: string;
}
export interface ISubscriptionSCForSale {
    id?: string;
    pack_house_id?: string;
    item_id?: string;
    item_name?: string;
    physical_availability_from_date?: number;
    physical_availability_to_date?: number;
    sales_availability_from?: number;
    sales_availability_to?: number;
    stock?: number;
    position?: number;
    remaining_stock?: number;
    limit_per_customer?: number;
    disable_sales?: boolean;
    archived?: boolean;
    stock_status?: EStockStatus;
    cf_is_excluded_from_global_limit?: boolean;
    promotion?: IPromotion;
}
export interface IDeliveryCost {
    every_week?: number;
    every_other_week?: number;
}
export interface IAnnouncementObject {
    message?: string;
    period_start?: number;
    period_end?: number;
}
export interface IDeliveryConfiguration {
    id?: string;
    name?: string;
    active?: boolean;
    hidden?: boolean;
    pack_house_id?: string;
    cutoff_day?: number;
    export_day?: number;
    cutoff_time?: string;
    delivery_day?: EDeliveryDay;
    delivery_time?: string;
    delivery_costs?: IDeliveryCost;
    custom_delivery_date?: string;
    announcement?: IAnnouncementObject;
}
export interface IListDeliveryConfigurationResponse {
    list?: Array<IDeliveryConfiguration>;
    next_page?: number;
    status?: string;
    error?: string;
}
export interface IBoxCustomisationConfigAvailableOptions {
    code?: string;
    name?: string;
    type?: string;
    order?: number;
}
export interface IBoxCustomisationConfigDefaultProduce {
    code?: string;
    name?: string;
    type?: string;
    order?: number;
    available_options?: Array<IBoxCustomisationConfigAvailableOptions>;
}
export interface IBoxCustomisationConfig {
    id?: string;
    box_composition_id?: string;
    box_id?: string;
    pack_house_id?: string;
    sales_availability_from?: number;
    sales_availability_to?: number;
    default_produce?: Array<IBoxCustomisationConfigDefaultProduce>;
    created_at?: number;
    updated_at?: number;
    archived?: boolean;
}
export interface IBoxCustomisationConfigList {
    list?: Array<IBoxCustomisationConfig>;
    next_page?: number;
}
export interface IBoxCustomisationSelection {
    id?: string;
    box_customisation_config_id?: string;
    subscription_id?: string;
    subscription_billing_date?: number;
    packhouse_box_composition_id?: string;
    product_code?: string;
    swapped_code?: string;
    updated_at?: number;
}
export interface IBoxCustomisationSelectionList {
    list?: Array<IBoxCustomisationSelection>;
}
export interface IBoxCustomisationProduceUnit {
    box_id?: string;
    value?: string;
}
export interface IBoxCustomisationProduce {
    code?: string;
    name?: string;
    type?: string;
    vanity_name?: string;
    unit?: Array<IBoxCustomisationProduceUnit>;
    image_url?: string;
    description?: string;
}
export interface IBoxCustomisationProduceItem {
    product?: IBoxCustomisationProduce;
}
export interface IBoxCustomisationProduceList {
    list?: Array<IBoxCustomisationProduce>;
}
export interface IProductCatalogItemPrice {
    id?: string;
    name?: string;
    currency_code?: string;
    period_unit?: string;
    period?: number;
    price?: number;
    cf_hidden?: boolean;
}
export interface IProductCatalogItem {
    id?: string;
    name?: string;
    type?: string;
    status?: string;
    description?: string;
    cf_hidden?: boolean;
    cf_imageurl?: string;
    cf_category?: string;
    cf_global_limit?: number;
    cf_is_excluded_from_global_limit?: boolean;
    prices?: Array<IProductCatalogItemPrice>;
}
export interface IProductCatalog {
    list?: Array<IProductCatalogItem>;
    next_page?: number;
}
export interface ICahcedProductCatalogItemPrice {
    id?: string;
    name?: string;
    currency_code?: string;
    period_unit?: string;
    period?: number;
    price?: number;
    cf_hidden?: boolean;
}
export interface IProductCatalogV2Object {
    id?: string;
    name?: string;
    label_name?: string;
    description?: string;
    status?: string;
    type?: string;
    packhouse?: string;
    tax_profile?: string;
    image_url?: string;
    price?: number;
    created_at?: number;
    updated_at?: number;
    prices?: Array<ICahcedProductCatalogItemPrice>;
    is_marketing_addon?: boolean;
    is_excluded_from_global_limit?: boolean;
    cf_category?: string;
    cf_global_limit?: number;
}
export interface IProductCatalogV2Response {
    item?: IProductCatalogV2Object;
}
export interface IListProductCatalogV2Response {
    list?: Array<IProductCatalogV2Object>;
    next_page?: number;
}
export interface IBoxCustomisationSelectionNotFound {
    error?: string;
}
export type TPackhouseV1ValidatePostCodePostError = '' | 'InvalidPostCode' | 'PostCodeNotServed';
export type TPackhouseV1ValidateDeliveryAddressPostError = '' | 'InvalidDeliveryAddress';
export type TPackhouseV1SalesConfigByDeliveryIdIdGetError = '' | 'InvalidParams' | 'EntityNotExist';
export type TPackhouseV1DeliveryConfigurationGetError = '' | 'InvalidParams';
export type TPackhouseV1DeliveryConfigurationIdGetError = '';
export type TPackhouseV1ProductCatalogGetError = '' | 'ItemTypeNotProvided';
export type TPackhouseV1ProductCatalogIdGetError = '' | 'EntityNotExist';
export type TPackhouseV2ProductCatalogGetError = '' | 'InvalidQueryParams';
export type TPackhouseV2ProductCatalogIdGetError = '' | 'ProductNotFound';
export type TPackhouseV1BoxCustomisationConfigByDeliveryIdIdGetError =
    | ''
    | 'BoxCustomisationConfigInvalidParams'
    | 'BoxCustomisationConfigNotFound';
export type TPackhouseV1SubscriptionIdBoxCustomisationSelectionPutError =
    | ''
    | 'InvalidParams'
    | 'Unauthorized'
    | 'BoxCustomisationConfigNotFound'
    | 'SubscriptionCustomiseBoxConflict'
    | 'SubscriptionIsNotCustomisable'
    | 'BoxCustomisationIsNotAvailable';
export type TPackhouseV1SubscriptionIdBoxCustomisationSelectionGetError =
    | ''
    | 'Unauthorized'
    | 'BoxCustomisationConfigNotFound';
export type TPackhouseV1ProduceGetError = '';
export type TPackhouseV1ProduceIdGetError = '' | 'BoxCustomisationProduceNotFound';
export type TPartialErrorCodes =
    | TPackhouseV1ValidatePostCodePostError
    | TPackhouseV1ValidateDeliveryAddressPostError
    | TPackhouseV1SalesConfigByDeliveryIdIdGetError
    | TPackhouseV1DeliveryConfigurationGetError
    | TPackhouseV1DeliveryConfigurationIdGetError
    | TPackhouseV1ProductCatalogGetError
    | TPackhouseV1ProductCatalogIdGetError
    | TPackhouseV2ProductCatalogGetError
    | TPackhouseV2ProductCatalogIdGetError
    | TPackhouseV1BoxCustomisationConfigByDeliveryIdIdGetError
    | TPackhouseV1SubscriptionIdBoxCustomisationSelectionPutError
    | TPackhouseV1SubscriptionIdBoxCustomisationSelectionGetError
    | TPackhouseV1ProduceGetError
    | TPackhouseV1ProduceIdGetError
    | '';

export const createApiRequest = (rs: IRequestService) => ({
    // validate UK postal code
    packhouseV1ValidatePostCodePost: (
        body: IPostcode,
    ): CustomPromise<
        CustomAxiosResponse<IValidePostcodeResponse, TPackhouseV1ValidatePostCodePostError>,
        IBEError<TPackhouseV1ValidatePostCodePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/packhouse/api/v1/validate_post_code`), body),

    // validate delivery address
    packhouseV1ValidateDeliveryAddressPost: (
        body: IAddress,
    ): CustomPromise<
        CustomAxiosResponse<IValideDeliveryAddress, TPackhouseV1ValidateDeliveryAddressPostError>,
        IBEError<TPackhouseV1ValidateDeliveryAddressPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/packhouse/api/v1/validate_delivery_address`), body),

    // get available SCs by DC ID
    packhouseV1SalesConfigByDeliveryIdIdGet: (
        delivery_configuration_id: string,
        query:
            | {
                  add_on_type?: EPackhouseV1SalesConfigByDeliveryIdIdGet_Add_on_type;
                  sales_availability_from?: number;
                  sales_availability_to?: number;
                  limit?: number;
                  page?: string;
              }
            | undefined,
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionSCsForSale, TPackhouseV1SalesConfigByDeliveryIdIdGetError>,
        IBEError<TPackhouseV1SalesConfigByDeliveryIdIdGetError>
    > =>
        rs.get(
            formatUrl(API_SERVER_URL + `/packhouse/api/v1/sales_config_by_delivery_id/${delivery_configuration_id}`, query),
        ),

    // receive a list of available delivery configurations
    packhouseV1DeliveryConfigurationGet: (
        query: { limit?: number; page?: number; postcode?: string } | undefined,
    ): CustomPromise<
        CustomAxiosResponse<IListDeliveryConfigurationResponse, TPackhouseV1DeliveryConfigurationGetError>,
        IBEError<TPackhouseV1DeliveryConfigurationGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v1/delivery_configuration`, query)),

    // get specific delivery configuration by ID
    packhouseV1DeliveryConfigurationIdGet: (
        delivery_configuration_id: string,
    ): CustomPromise<
        CustomAxiosResponse<IDeliveryConfiguration, TPackhouseV1DeliveryConfigurationIdGetError>,
        IBEError<TPackhouseV1DeliveryConfigurationIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v1/delivery_configuration/${delivery_configuration_id}`)),

    // receive a product catalog
    packhouseV1ProductCatalogGet: (
        query: { limit?: number; page?: number; type?: EPackhouseV1ProductCatalogGet_Type; name?: string } | undefined,
    ): CustomPromise<
        CustomAxiosResponse<IProductCatalog, TPackhouseV1ProductCatalogGetError>,
        IBEError<TPackhouseV1ProductCatalogGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v1/product_catalog`, query)),

    // receive specific product from product catalog
    packhouseV1ProductCatalogIdGet: (
        product_id: string,
    ): CustomPromise<
        CustomAxiosResponse<IProductCatalogItem, TPackhouseV1ProductCatalogIdGetError>,
        IBEError<TPackhouseV1ProductCatalogIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v1/product_catalog/${product_id}`)),

    // fetch products list from ProductCatalog v2
    packhouseV2ProductCatalogGet: (
        query:
            | {
                  type?: EPackhouseV2ProductCatalogGet_Type;
                  sku?: string;
                  name?: string;
                  status?: EPackhouseV2ProductCatalogGet_Status;
                  next_page?: number;
                  limit?: number;
              }
            | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IListProductCatalogV2Response, TPackhouseV2ProductCatalogGetError>,
        IBEError<TPackhouseV2ProductCatalogGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v2/product_catalog`, query), { headers }),

    // fetch product from ProductCatalog v2
    packhouseV2ProductCatalogIdGet: (
        product_id: string,
        query: { type?: EPackhouseV2ProductCatalogIdGet_Type } | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IProductCatalogV2Response, TPackhouseV2ProductCatalogIdGetError>,
        IBEError<TPackhouseV2ProductCatalogIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v2/product_catalog/${product_id}`, query), { headers }),

    // retrieve available Box Customisation Configs by DC ID
    packhouseV1BoxCustomisationConfigByDeliveryIdIdGet: (
        delivery_configuration_id: string,
        query: { delivery_date?: number } | undefined,
    ): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationConfigList, TPackhouseV1BoxCustomisationConfigByDeliveryIdIdGetError>,
        IBEError<TPackhouseV1BoxCustomisationConfigByDeliveryIdIdGetError>
    > =>
        rs.get(
            formatUrl(
                API_SERVER_URL + `/packhouse/api/v1/box_customisation_config_by_delivery_id/${delivery_configuration_id}`,
                query,
            ),
        ),

    // update box customisations for specified Subscription
    packhouseV1SubscriptionIdBoxCustomisationSelectionPut: (
        subscription_id: string,
        body: IPutBoxCustomisationSelectionRequestBody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationSelectionList, TPackhouseV1SubscriptionIdBoxCustomisationSelectionPutError>,
        IBEError<TPackhouseV1SubscriptionIdBoxCustomisationSelectionPutError>
    > =>
        rs.put(
            formatUrl(API_SERVER_URL + `/packhouse/api/v1/subscription/${subscription_id}/box_customisation_selection`),
            body,
            { headers },
        ),

    // retrieve box customisation selections (if no config id specified then current selections retrieved)
    packhouseV1SubscriptionIdBoxCustomisationSelectionGet: (
        subscription_id: string,
        query: { box_customisation_config_id?: string } | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationSelectionList, TPackhouseV1SubscriptionIdBoxCustomisationSelectionGetError>,
        IBEError<TPackhouseV1SubscriptionIdBoxCustomisationSelectionGetError>
    > =>
        rs.get(
            formatUrl(
                API_SERVER_URL + `/packhouse/api/v1/subscription/${subscription_id}/box_customisation_selection`,
                query,
            ),
            { headers },
        ),

    // Retrieve all Box Customisation Produce
    packhouseV1ProduceGet: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationProduceList, TPackhouseV1ProduceGetError>,
        IBEError<TPackhouseV1ProduceGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v1/produce`), { headers }),

    // Get certain Box Customisation Produce
    packhouseV1ProduceIdGet: (
        product_code: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationProduceItem, TPackhouseV1ProduceIdGetError>,
        IBEError<TPackhouseV1ProduceIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/packhouse/api/v1/produce/${product_code}`), { headers }),
});

const URL = {
    packhouseV1ValidatePostCodePost: (): string => `/packhouse/api/v1/validate_post_code`,
    packhouseV1ValidateDeliveryAddressPost: (): string => `/packhouse/api/v1/validate_delivery_address`,
    packhouseV1SalesConfigByDeliveryIdIdGet: (delivery_configuration_id: string): string =>
        `/packhouse/api/v1/sales_config_by_delivery_id/${delivery_configuration_id}`,
    packhouseV1DeliveryConfigurationGet: (): string => `/packhouse/api/v1/delivery_configuration`,
    packhouseV1DeliveryConfigurationIdGet: (delivery_configuration_id: string): string =>
        `/packhouse/api/v1/delivery_configuration/${delivery_configuration_id}`,
    packhouseV1ProductCatalogGet: (): string => `/packhouse/api/v1/product_catalog`,
    packhouseV1ProductCatalogIdGet: (product_id: string): string => `/packhouse/api/v1/product_catalog/${product_id}`,
    packhouseV2ProductCatalogGet: (): string => `/packhouse/api/v2/product_catalog`,
    packhouseV2ProductCatalogIdGet: (product_id: string): string => `/packhouse/api/v2/product_catalog/${product_id}`,
    packhouseV1BoxCustomisationConfigByDeliveryIdIdGet: (delivery_configuration_id: string): string =>
        `/packhouse/api/v1/box_customisation_config_by_delivery_id/${delivery_configuration_id}`,
    packhouseV1SubscriptionIdBoxCustomisationSelectionPut: (subscription_id: string): string =>
        `/packhouse/api/v1/subscription/${subscription_id}/box_customisation_selection`,
    packhouseV1SubscriptionIdBoxCustomisationSelectionGet: (subscription_id: string): string =>
        `/packhouse/api/v1/subscription/${subscription_id}/box_customisation_selection`,
    packhouseV1ProduceGet: (): string => `/packhouse/api/v1/produce`,
    packhouseV1ProduceIdGet: (product_code: string): string => `/packhouse/api/v1/produce/${product_code}`,
};
// INSERT END
// DON'T REMOVE THIS COMMENTS!!!

export const packHouseApiRequest = {
    ...createApiRequest(requestService),
};
export const PACKHOUSE_API_URL = URL;
export type IPackHouseApiRequest = Partial<typeof packHouseApiRequest>;
